//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MoreIcon from '@/components/views/_more_icon'
import ClientMark from '@/components/views/_client_mark'
import UserDlg from './_user_dlg'
export default {
    components: {
        UserDlg,
        ClientMark,
        MoreIcon
    },
    props: {
        client_mark: String,
        peer_persona: Object,
        building: {
            type: Object
        },
        peer_headimgurl: {
            type: String
        },
        peer_nickname: {
            type: String
        },
        ask_phone_status: {
            type: String
        },
        is_block: {
            type: Boolean
        },
        is_juli: Boolean
    },
    data () {
        return {
            show_user_dlg: false
        }
    },
    computed: {
        ask_enable () {
            return this.ask_phone_status === 'none'
        },
        show_user_data () {
            return this.peer_persona && this.peer_persona.nickname
        }
    },
    methods: {
        hide() {
            this.show_user_dlg = false
            this.$emit('toggleBottomWrapShow')
        },
        showUserData () {
            this.show_user_dlg = true
            this.$emit('toggleBottomWrapShow')
            this.$sendCtmEvtLog('微聊-大数据分析')
        },
        askPhone () {
            if (!this.ask_enable) {
                return
            }
            const content = this.is_juli ? '对单个用户仅可索要一次电话号码，用户拒绝授权手机号码后不可再次索要，请把握好索要时机。' : '向客户索要电话，将消耗20积分（客户拒绝或未响应，积分不退回），不影响活跃度，是否确认索要？'
            wx.showModal({
                title: '提示',
                content,
                success: ({ confirm }) => {
                    if (confirm) {
                        this.$emit('ask')
                    }
                }
            })
            this.$sendCtmEvtLog('微聊-索要电话号码')
        },
        getMore() {
            const data = this.is_block ? ['取消屏蔽'] : ['屏蔽消息']
            wx.showActionSheet({
                itemList: data,
                success: (res) =>  {
                    this.$emit('changeBlock', data.join(''))
                }
            })
        }
    }
}
